import { createContext, useCallback, useMemo, useState } from 'react';

type TexasChatContextType = {
  isOpen: boolean;
  messages?: any[];
  toggle: () => void;
  setIsOpen: (flag: boolean) => void;
};

export const TexasChatContext = createContext<TexasChatContextType>({
  isOpen: false,
  messages: [],
  toggle: () => {},
  setIsOpen: (_: boolean) => {}
});

export const TexasChatContextProvider = ({ children }: any) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, []);

  // PERF: memoized so consumers only re-render when one of these values
  // actually changes, not on every provider re-render. See
  // docs/investigations/20260819-game-client-overheating.md.
  const value = useMemo(() => ({ isOpen, setIsOpen, toggle }), [isOpen, toggle]);

  return <TexasChatContext.Provider value={value}>{children}</TexasChatContext.Provider>;
};

export default TexasChatContext;
